module.exports = __webpack_public_path__ + "img/shurakov.8e0eb6b8.png";